import {
  BaseResource,
  IdResourceParam,
  paginatedListSerializer,
  ResourceAction,
  ResourceActionV2,
} from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

export interface UserListFilters {
  limit?: number;
  offset?: number;
  searchText?: string;
  /**
   * @deprecated
   */
  search?: string;
  includeDeleted?: boolean;
}
export interface UserSimple {
  id: number;
  email: string;
  isDeleted: boolean;
}
export interface UserDto {
  id: number;
  email: string;

  groups: {
    uuid: string;
    name: string;
  }[];

  isDeleted: boolean;
}
export interface UserProfileDto {
  user: {
    id: number;
    email: string;
  };
  firstName?: string;
  lastName?: string;
  pictureUrl?: string | null;
}
export interface UserProfileListFilters {
  limit?: number;
  offset?: number;
  searchText?: string;
}

export interface GroupReference {
  uuid: string;
}

export interface UpdateUserInput {
  email: string;
  groups: GroupReference[];
}

export interface NewUserInput {
  email: string;
  groups: GroupReference[];
}

const list = ResourceAction({
  name: "list",
  method: "get",
  path: "",
  querySerializer: MSerializers.object<UserListFilters>({
    searchText: MSerializers.string.optional(),
    search: MSerializers.string.optional(),
    limit: MSerializers.integer.optional(),
    offset: MSerializers.integer.optional(),
    includeDeleted: MSerializers.boolean.optional(),
  }),
  responseSerializer: paginatedListSerializer(
    MSerializers.object<UserSimple>({
      id: MSerializers.integer,
      email: MSerializers.string,
      isDeleted: MSerializers.boolean,
    }),
  ),
});

export const userResource = BaseResource(["iam", "users"], {
  current: ResourceAction({
    name: "currentUser",
    method: "get",
    path: "current",
    responseSerializer: MSerializers.object({
      id: MSerializers.integer,
      email: MSerializers.string,
    }),
  }),
  list,
  byId: IdResourceParam("userId", {
    retrieve: ResourceAction({
      name: "retrieve",
      method: "get",
      path: "",
      responseSerializer: MSerializers.object<UserDto>({
        email: MSerializers.string,
        id: MSerializers.integer,
        groups: MSerializers.array(
          MSerializers.object({
            name: MSerializers.string,
            uuid: MSerializers.uuid(),
          }),
        ),
        isDeleted: MSerializers.boolean,
      }),
    }),
  }),
});

export const userProfileDtoSerializer = MSerializers.object<UserProfileDto>({
  user: MSerializers.object({
    id: MSerializers.integer,
    email: MSerializers.string,
  }),
  firstName: MSerializers.string.optional(),
  lastName: MSerializers.string.optional(),
  pictureUrl: MSerializers.optional(MSerializers.string.nullable()),
});

const userProfileListAction = ResourceAction({
  name: "all",
  method: "get",
  path: "",
  responseSerializer: paginatedListSerializer(userProfileDtoSerializer),
  querySerializer: MSerializers.object<UserProfileListFilters>({
    limit: MSerializers.integer.optional(),
    offset: MSerializers.integer.optional(),
    searchText: MSerializers.string.optional(),
  }),
});

export const profileResource = BaseResource(["iam", "profiles"], {
  byId: IdResourceParam("userId", {
    retrieve: ResourceAction({
      name: "retrieve",
      method: "get",
      path: "",
      responseSerializer: userProfileDtoSerializer,
    }),
  }),
  list: userProfileListAction,
});
